module.exports = __webpack_public_path__ + "static/media/brand-story-meaning2.81572ce1.png";